import { useEffect } from "react";
import { IntlProvider } from "react-intl";
import { CssBaseline } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  selectLanguage,
  setLanguage,
} from "@/redux/features/Setting/Language/languageSlice";
import useRoutes from "@/useHooks/useRoutes";
import Language from "./enums/Language";
import { AlertDialogProvider } from "@/useHooks/Dialog/AlertDialogProvider";
import AlertDialog from "@/components/Dialog/AlertDialog";

const App = () => {

  const dispatch = useAppDispatch();

  const systemLanguage = useAppSelector(selectLanguage);

  const defaultLanguage = navigator.language;

  const routes = useRoutes();

  useEffect(() => {

    if (defaultLanguage === "en-US") {
      dispatch(setLanguage(Language.en_US));
    } else {
      dispatch(setLanguage(Language.zh_TW));
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLanguage]);

  return (
    <IntlProvider
      locale={systemLanguage.language}
      messages={systemLanguage.messages}
    >
      <AlertDialogProvider>
        <CssBaseline />
        {routes}
        <AlertDialog />
      </AlertDialogProvider>
    </IntlProvider>
  );
};

export default App;
